export const environment = {
    production: true,
    apiUrl: 'https://rewardsservices.griris.com/clientportal/',
    secretAesKey: 'eJ+VCJ0auu9Fx+GsyjBVm9pIPHjjU2xl01rt78naWbM=',
    clientTemplateDomain:"https://rewardsservices.griris.com/",
    blobExcelDomain: "https://imageserver.griris.com/data/ExcelFolder/",
    OrderExcelDomain: "https://imageserver.griris.com/data/",
 
  };
  